import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'src/lang/i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import store from 'src/configStore';
// import { Provider } from 'react-redux';

function noop() {}

if (process.env.NODE_ENV !== 'development') {
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}

declare global {
  interface Window {
    ReactNativeWebView?: any;
    config?: any;
  }
}

window.ReactNativeWebView = window.ReactNativeWebView || null;

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// "start": "react-scripts start",
// "build": "react-scripts build",
// "test": "react-scripts test",
